import { render, staticRenderFns } from "./ChatContactList.vue?vue&type=template&id=07023604&"
import script from "./ChatContactList.vue?vue&type=script&lang=ts&"
export * from "./ChatContactList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports